import { publicApi } from './apiClient'
import { tokenManager } from './tokenManager'
import type {
    LoginCredentials,
    AuthResponse,
    AuthUser,
    AuthResponseData,
} from '../types'

interface RefreshResult {
    token: string
    user: AuthUser
    initData: Record<string, unknown>
    expires_in: number
}

class AuthService {
    async login(credentials: LoginCredentials): Promise<AuthResponse> {
        const response = await publicApi.post('/auth/login', credentials, {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true,
        })

        const data = response.data as AuthResponse

        if (data.success) {
            const { token, expires_in } = data.data as AuthResponseData
            tokenManager.setToken(token, expires_in)
        }

        return data
    }

    async refresh(): Promise<RefreshResult | null> {
        const response = await publicApi.get('/auth/refresh-token')

        const data = response.data as AuthResponse

        if (data.success) {
            const { token, user, initData, expires_in } =
                data.data as AuthResponseData
            tokenManager.setToken(token, expires_in)
            return { token, user, initData, expires_in }
        }

        return null
    }

    async logout(): Promise<void> {
        try {
            await publicApi.get('/auth/logout', { withCredentials: true })
        } finally {
            tokenManager.clear()
        }
    }

    async reAuthenticate(
        username: string,
        password: string
    ): Promise<AuthResponse> {
        return this.login({ username, password })
    }
}

export const authService = new AuthService()
